import { useAuth } from '@/contexts/AuthContext';
import OnePager from '@/components/OnePager';
import Onboarding from './Onboarding';
import Landing from './Landing';
import { IntroScreen } from '@/components/IntroScreen';
import { ScheduledChallenge } from '@/components/ScheduledChallenge';

export default function Index() {
  const { user, profile, membership, loading, challengeStatus, bootState } = useAuth();

  // Gate ALL rendering on boot completion — prevents flicker and premature evaluation
  if (bootState !== 'ready') {
    return <IntroScreen />;
  }

  // Not authenticated - show landing page
  if (!user) {
    return <Landing />;
  }

  // User exists but email not confirmed - show landing with prompt to check email
  if (!user.email_confirmed_at) {
    return <Landing />;
  }

  // User needs to complete onboarding (no user_id or no group)
  if (!profile?.user_id || !membership) {
    return <Onboarding />;
  }

  // Challenge is scheduled (starts in the future) - show countdown screen
  if (challengeStatus === 'scheduled') {
    return <ScheduledChallenge />;
  }

  // Fully onboarded with active challenge - show one-pager
  return <OnePager />;
}
